import MarkerData from 'media/models/marker-data'
import MarkerCollection from 'media/models/marker-collection'
import MapData from 'media/models/map-data'


module.exports = { MarkerData, MarkerCollection, MapData }
